/*
 * Copyright: Infosim GmbH & Co. KG Copyright (c) 2000-2021
 * Company: Infosim GmbH & Co. KG,
 *                  Landsteinerstraße 4,
 *                  97074 Wuerzburg, Germany
 *                  www.infosim.net
 */
import { Component } from '@angular/core';
import { AuthGuard } from './auth/auth.guard';
import { LoginGuard } from './auth/login.guard';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'aio-shell',
  templateUrl: './app.component.html',
})
export class AppComponent {
  cookieNotice = true;

  constructor(public authGuard: AuthGuard, public loginGuard: LoginGuard, private cookieService: CookieService) {
    this.cookieNotice = !this.cookieService.check('cookies-notice');
  }

  dismissCookieNotice() {
    this.cookieNotice = false;
    this.cookieService.set('cookies-notice', 'ok', 365, '/');
  }
}
